import React from 'react'
import MainLayout from '../../layouts/Main'
import { PageTitle } from '../../components'
import { container as Conferences } from '../../modules/Conferences'
import './styles.css'



const ConferencesView = () => {
    return (
        <MainLayout>
            <div className="row">
                <div className="col">
                    <PageTitle>Научни форуми</PageTitle>
                </div>
            </div>
            <div className="row justify-content-center">
                <main className="col-md-12 col-lg-10">
                    <Conferences/>
                </main>
            </div>
        </MainLayout>
    )
}


export default ConferencesView



// WEBPACK FOOTER //
// ./src/views/Conferences/index.js